// extracted by mini-css-extract-plugin
export default {"stosks_column":"styles_stosks_column__iiNrO","link_download":"styles_link_download__AmTiW","main_block":"styles_main_block__f0x0A","text_time":"styles_text_time__9ieXl"};